import { Container, Page, ContentHeader } from 'components'
import { Box, makeStyles, Grid } from '@material-ui/core'
import { ReportsList } from './components'

import styles from './styles'
import constants from 'constants/index'

const useStyles = makeStyles(styles)

const ReportsMain = () => {
  const classes = useStyles()

  return (
    <Page className={classes.root} title="Relatórios">
      <Container maxWidth={false}>
        <Box mb={6}>
          <ContentHeader
            title="Relatórios"
            menu="Relatórios"
            subtitle="Relatórios"
          />
        </Box>
        <Grid container spacing={3}>
          <Grid item lg={12}>
            {constants.reportOptions.ITEMS &&
              constants.reportOptions.ITEMS.map((item) => (
                <ReportsList
                  key={item.title}
                  icon={item.icon}
                  title={item.title}
                  subtitle={item.subtitle}
                  href={item.href}
                />
              ))}
          </Grid>
        </Grid>
      </Container>
    </Page>
  )
}

export default ReportsMain
